export default __webpack_public_path__ + "static/media/mandala.127b7f4b.svg";